// 开发环境
const ENV = process.env.VUE_APP_ENV
export const isDev = ENV === "dev"
export const isTest = ENV === "test"
export const isOnline = ENV === "online"
export const isStaging = isOnline && window.location.href.includes("staging") // 预上线模式

// 浏览器环境
export const inBrowser = typeof window !== "undefined"
export const UA = inBrowser && window.navigator.userAgent.toLowerCase()
export const isWechat = UA && /micromessenger/.test(UA) && !/miniProgram/i.test(UA)
export const isMiniApp = UA && /micromessenger/.test(UA) && /miniProgram/i.test(UA)
export const isiOS = UA && /iphone|ipad|ipod|ios/.test(UA)
export const isAndroid = UA && /Android/i.test(UA)

// 猿辅导APP矩阵
export const isApp = UA && /Aries/i.test(UA) // 海豚AI学
export const isZeta = UA && /Zeta/i.test(UA) // 海豚Zeta（国外）
export const isZebra = UA && /Zebra/i.test(UA) // 斑马APP
export const isFudao = UA && /YuanFuDao/i.test(UA) // 猿辅导
export const isTiku = UA && !isZebra && /YuanTiKu/i.test(UA) // 猿题库
export const isSouti = UA && /YuanSouTi(?!KouSuan)/i.test(UA) // 猿搜题
export const isKousuan = UA && /YuanSouTiKouSuan/i.test(UA) // 猿口算

// 类型判断
export const isPlainObject = (v) => {
  return Object.prototype.toString.call(v) === "[object Object]"
}

export const isArray = (v) => {
  return Array.isArray(v)
}

export const isArrayNoneEmpty = (v) => {
  return isArray(v) && v.length
}

export const isString = (v) => {
  return typeof v === "string"
}

export const isFunction = (v) => {
  return typeof v === "function"
}

export const isNumber = (v) => {
  return typeof v === "number" && !isNaN(v)
}

export const isComponentName = (v) => {
  return /^[a-zA-Z_][a-zA-Z0-9_-]*/gi.test(v)
}

export const isPromise = (v) => {
  return (
    isFunction(v) &&
    isFunction(v.resolve) &&
    isFunction(v.reject) &&
    isFunction(v.prototype.then) &&
    isFunction(v.prototype.catch)
  )
}

// https://zhuanlan.zhihu.com/p/24555031
// 对于滚动事件的优化处理
export const supportsPassive = (function () {
  let isSupport = false
  try {
    const opts = Object.defineProperty({}, "passive", {
      get() {
        isSupport = true
        return ""
      }
    })
    window.addEventListener("test", null, opts)
    return isSupport
  } catch (e) {
    return isSupport
  }
})()

export const hasPropery = (obj, key) => {
  return Object.prototype.hasOwnProperty.call(obj, key)
}

// 空函数
export const noopfunc = function () {}

// 空vm组件
export const noopvm = {
  render(h) {
    return h("div")
  }
}

// 空用户
export const noopuser = {
  phone: "",
  userId: "",
  name: "",
  avatarUrl: "",
  openId: 0,
  trial: false,
  isLogin: false
}

// 延迟函数
export const delay = function (timer = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, timer)
  })
}

// 按索引获取字母表
export function getAlphabet({ index, upper = false }) {
  const start = upper ? 65 : 97
  return String.fromCharCode(start + index)
}

// 获取猿辅导系APP版本
export const getAppVersion = () => {
  const UA_REGEX =
    /\s+(YuanTiKu|YuanFuDao|YuanSouTi|YuanSouTiKouSuan|Aries|Zeta)\/(\d+\.\d+\.\d+)(\s+|$)/i
  const matches = navigator.userAgent.replace("(Test)", "").match(UA_REGEX)
  return matches ? matches[2] : ""
}

/**
 * APP版本判断 V1 > V2
 * @return {0} v1 === v2
 * @return {1} v1 > v2
 * @return {-1} v1 < v2
 */
export const compareVersions = (v1, v2) => {
  if (v1 === v2) {
    return 0
  }
  const v1parts = v1.split(".")
  const v2parts = v2.split(".")
  const len = Math.min(v1parts.length, v2parts.length)

  for (let i = 0; i < len; i++) {
    if (parseInt(v1parts[i]) > parseInt(v2parts[i])) {
      return 1
    }
    if (parseInt(v1parts[i]) < parseInt(v2parts[i])) {
      return -1
    }
  }

  if (v1parts.length > v2parts.length) {
    return 1
  }
  if (v1parts.length < v2parts.length) {
    return -1
  }

  return 0
}
